/**
 * Role-based permissions for the shared Student Detail dashboard.
 *
 * The same StudentDashboard + tabs are rendered in both the Admin portal and
 * the Tutor portal. Permissions decide which areas are editable. Tabs receive
 * a resolved `permissions` object via shared tab props and gate their own
 * editing affordances — they never need to know about roles directly.
 *
 * Flags
 *  - editInfo:       edit personal/contact/parent/notes/intake on the Info tab
 *  - editSchool:     edit courses, grades, plan, and login info on the School tab
 *  - linkTest:       link / re-link diagnostic report accounts on the Test tab
 *  - editConference: create / edit / delete conference notes
 *  - editCalendar:   create / edit / delete scheduled sessions on the Calendar
 *  - manageReports:  rename / delete generated progress reports on Sessions
 *  - managePlans:    create / edit / duplicate / archive plans (incl. custom plans)
 *  - requestPlanDeletion: soft-delete a plan (admin restores or purges within 30 days)
 *  - manageDeletedPlans:  restore a pending deletion or delete it permanently (admin)
 */
export const ADMIN_PERMISSIONS = {
  editInfo: true,
  editSchool: true,
  linkTest: true,
  editConference: true,
  editCalendar: true,
  manageReports: true,
  managePlans: true,
  requestPlanDeletion: true,
  manageDeletedPlans: true,
};

// Tutors share the full viewing experience but may only edit the School tab and
// author/edit plans. Permanent plan deletion stays with admins.
export const TUTOR_PERMISSIONS = {
  editInfo: false,
  editSchool: true,
  linkTest: false,
  editConference: false,
  editCalendar: false,
  manageReports: false,
  managePlans: true,
  requestPlanDeletion: true,
  manageDeletedPlans: false,
};

export function resolvePermissions(permissions) {
  return { ...ADMIN_PERMISSIONS, ...(permissions || {}) };
}
